module.exports = __webpack_public_path__ + "static/style-995a1e3bbab5ec961c3433ee2dbc08ef.png";